import {
  ListItemText,
  Typography,
  Chip,
} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { IssueType } from './types';
import { ReactComponent as File } from "assets/images/file.svg";
import { icons } from "constants/viewer";
import * as Utils from "services/UtilsService";
import { tss } from "tss-react";

const useStyles = tss.create(() => ({
  icon: {
    width: 27,
    height: 27,
    marginRight: 10,
    color: 'rgb(0,0,0,0.53)',
  },
  layerIcon: {
    display: "inline-flex",
    alignItems: "center",
  },
}));

const getIcon = (fileName: string, classes: any) => {
  if (!fileName) {
      return <File className={classes.icon} />;
  }
  const Icon = icons[fileName];
  return (
      <div className={classes.layerIcon}>
          <Icon className={classes.icon} />
      </div>
  );
}

const IssueItem = ({ item }: {item:IssueType}) => {
  const { classes } = useStyles();
  return (
    <ListItemButton
      component={'li'}
      sx={{
        p: '8px 24px',
        transition: 'all 0.2s',
        pointerEvents: 'none'
      }}
    >
      {getIcon(item.fileName, classes)}
      <ListItemText
        primary={
          <Typography variant={'h5'} mb={0.5} className='listItemTitle'>
            {item.name}
          </Typography>
        }
        secondary={
          <Typography variant={'h6'} mb={0.5} color={'text.secondary'} style={{fontSize: '12px'}}>
            {item.projectName}
          </Typography>
        }
        sx={{ width:'50%' }}
      />
      {/* {item.workflow === null ? (
        <Chip
          label="..."
          size={'small'}
          style={{ backgroundColor: '#ffc248' }}
        />
      ) : (
        <Chip
          label={`${item.workflow.version}`}
          size={'small'}
          style={{ backgroundColor: 'rgb(115, 173, 33)' }}
        />
      )} */}
      <ListItemText
        primary={
          <Typography variant={'h6'} color={'text.secondary'} style={{fontSize: '13px'}}>
            {item.date ? Utils.formatDateWithTime(item.date) : "---"}
          </Typography>
        }
        sx={{display: {xs: 'none', sm:'none', md:'flex', lg:'flex', xl:'flex'}, pt: '6px', justifyContent: 'flex-end'}}
      />
    </ListItemButton>
  );
};

export { IssueItem };
